import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo';
const VolumnControl = (props) => {
    const { t } = useTranslation()
    const [data, setData] = useState([]);
    const [globalVolume, setGlobalVolume] = useState(true); // 初始值為ture
    // 改良的 API 資料獲取函數，適應新的 API 格式
    function API_GET() {
        ApiGo.getALLMac_alert_setting()
            .then(response => {
                try {
                    const processedData = processApiData(response); // Process data
                    setData(processedData); // Update state with processed data
                    // Update global volume state (all items are "on")
                    const allOn = processedData.some(item => item.volume_control > 0);
                    setGlobalVolume(allOn);
                } catch (error) {
                    console.error("Error processing API data:", error);
                }
            })
            .catch(err => {
                console.error("Error fetching MAC alert settings:", err);
            });
    }
    useEffect(() => {
        API_GET()
    }, [t])

    function handleVolumeChange(mac, currentValue) {
        const newValue = currentValue > 0 ? 0 : 30; // 切換音量值
        ApiGo.putUpdate_Mac_Volumn_Alert_Setting({ mac, volume_control: newValue })
            .then(() => {

                API_GET(); // 更新全域狀態
            })
            .catch(err => {
                console.error(`更新音量控制失敗 for MAC ${mac}:`, err);
            });
    }

    function handleGlobalVolumeChange() {
        const newValue = globalVolume ? 0 : 30;
        const updatePromises = data.map(item =>
            ApiGo.putUpdate_Mac_Volumn_Alert_Setting({ volume_control: newValue, mac: item.mac })
        );

        Promise.all(updatePromises)
            .then(() => {
                setGlobalVolume(globalVolume);
                API_GET();
            })
            .catch(err => {
                console.error('Error updating global volume control:', err);
            });
    }


    return (
        <div className='fx-d-c font-m bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs gap10'>
            {/* 語音告警開關調整 */}
            <div className="font-l margl-xs h-100 margt-xxs">{t('ADMIN.Voice_Base_Station_Control_Panel')}</div>
            <div className='fx-d-r'>
                <div className='margl-xs font-ml w-30'>{t("ADMIN.ALL")} {t("ADMIN.MUTE_UNMUTE")}</div>
                <div
                    className={`btn_switch_RES_admin beige cursor pt ${globalVolume ? "on_Click_admin" : ''}`}
                    onClick={handleGlobalVolumeChange}
                ></div>
            </div>
            {/* 個別開關 */}
            <div className='margl-xs font-ml mar-30 t'>{t('ADMIN.INDIVIDUAL_SWITCH')}</div>
            <div>
                <div className='fx-d-r margl-xs'>
                    <div className='w-30'>{t("NAV_BAR.PADS")}</div>
                    <div className='w-20'>{t("GLOBAL.BED_NO")}</div>
                    <div className='w-20'>{t("NAV_BAR.RESIDENTS")}</div>
                    <div> {t("ADMIN.MUTE_UNMUTE")}</div>
                </div>
                <div className='fx-d-c gap20 mar-15 t'>

                    {data.map((item, index) => {
                        return (
                            <div key={index} className='fx-d-r fx-fsc margl-xs'>
                                <div className='w-30'>{item.mac}</div>
                                <div className='w-20'>{item.first_name}</div>
                                <div className='w-20'>{item.last_name}</div>
                                <div
                                    className={`btn_switch_RES_admin beige cursor pt ${item.volume_control > 0 ? "on_Click_admin" : ''}`}
                                    onClick={() => handleVolumeChange(item.mac, item.volume_control)}
                                ></div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );

}
export default VolumnControl;

function processApiData(apiResponse) {
    // Check if the response is valid and contains the required structure
    if (!Array.isArray(apiResponse)) {
        console.error("Invalid API response format:", apiResponse);
        return [];
    }

    return apiResponse
        .filter(item => item.mac !== "MAC_ALERT_SETTING") // 過濾不需要的項目
        .map(item => ({
            mac: item.mac,
            volume_control: item.volume_control, // 預設音量值為 30
            first_name: item.first_name || "-",       // 預設姓名為 "-"
            last_name: item.last_name || "-"          // 預設姓氏為 "-"
        }));

}